import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconGradient24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconGradient24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M9.559 5.5h1.88L3.5 13.44v-1.881l.03-.029 6-6zm-2.12 0H5A1.5 1.5 0 0 0 3.5 7v2.44zm5.591.53a.75.75 0 0 0 .22-.53H19A1.5 1.5 0 0 1 20.5 7v10a1.5 1.5 0 0 1-1.5 1.5h-6.44l.47-.47a.75.75 0 1 0-1.06-1.06l-1.5 1.5-.029.03h-1.88l4.47-4.47a.75.75 0 1 0-1.061-1.06l-5.5 5.5-.029.03H5q-.202-.001-.389-.05l8.42-8.42a.75.75 0 1 0-1.061-1.06l-8.42 8.419A1.5 1.5 0 0 1 3.5 17v-1.441l.03-.029zM2 7a3 3 0 0 1 3-3h14a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconGradient24);
